<template>
  <div
    class="cherk-element-card"
    :class="{
      'cherk-element-card--error': hasError,
      'cherk-element-card--expanded': expanded,
    }"
  >
    <!-- ───────────── HEADER ───────────── -->
    <div class="cherk-element-card__header" @click="toggle">

      <!-- ROW 1: Название цели + actions + chevron -->
      <div class="cherk-element-card__header-row cherk-element-card__header-row--title">
        <div
          class="cherk-element-card__title"
          @click.stop
        >
          <card-section-element-card-field
            v-for="(field, i) in titleFields"
            :key="'title-' + i"
            :column-config="field"
            :element="element"
            @elements-changed="$emit('elements-changed')"
          />
        </div>

        <!-- Actions -->
        <div
          v-if="actionFields.length"
          class="cherk-element-card__actions"
          @click.stop
        >
          <card-section-element-card-field
            v-for="(field, i) in actionFields"
            :key="'action-' + i"
            :column-config="field"
            :element="element"
            @elements-changed="$emit('elements-changed')"
          />
        </div>

        <el-button
          class="cherk-element-card__chevron"
          type="text"
          :icon="expanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
          @click.stop="toggle"
        />
      </div>

      <!-- ROW 2: Stats + highlighted meta (взвешенный %) -->
      <div
        v-if="statsFields.length || metaFields.length"
        class="cherk-element-card__header-row cherk-element-card__header-row--stats"
        @click.stop
      >
        <!-- Regular stat pills -->
        <div class="cherk-element-card__stats">
          <div
            v-for="(field, i) in statsFields"
            :key="'stat-' + i"
            class="cherk-element-card__stat"
          >
            <span class="cherk-element-card__stat-label">{{ field.label }}</span>
            <card-section-element-card-field
              :column-config="field"
              :element="element"
              @elements-changed="$emit('elements-changed')"
            />
          </div>
        </div>

        <!-- Meta: highlighted bonus pill -->
        <div
          v-for="(field, i) in metaFields"
          :key="'meta-' + i"
          class="cherk-element-card__meta-bonus"
        >
          <span class="cherk-element-card__meta-bonus-label">{{ field.label }}</span>
          <span class="cherk-element-card__meta-bonus-value">
            <card-section-element-card-field
              :column-config="field"
              :element="element"
              @elements-changed="$emit('elements-changed')"
            />
          </span>
        </div>
      </div>

    </div>

    <!-- ───────────── BODY ───────────── -->
    <div
      v-show="expanded"
      class="cherk-element-card__body"
    >
      <!-- LEFT column -->
      <div class="cherk-element-card__body-left">

        <!-- 1. Шкала оценки — full width -->
        <div
          v-for="(field, i) in mainScaleFields"
          :key="'scale-' + i"
          class="cherk-element-card__box"
        >
          <div class="cherk-element-card__box-label">{{ field.label }}</div>
          <card-section-element-card-field
            :column-config="field"
            :element="element"
            @elements-changed="$emit('elements-changed')"
          />
        </div>

        <!-- 2. Парты — 3 columns, taller -->
        <div
          v-if="mainPartsFields.length"
          class="cherk-element-card__parts"
        >
          <card-section-element-card-field
            v-for="(field, i) in mainPartsFields"
            :key="'parts-' + i"
            :column-config="field"
            :element="element"
            @elements-changed="$emit('elements-changed')"
          />
        </div>

        <!-- 3. Info row: Ответственный / ID / ID Парт -->
        <div
          v-if="mainInfoFields.length"
          class="cherk-element-card__info-row"
        >
          <div
            v-for="(field, i) in mainInfoFields"
            :key="'info-' + i"
            class="cherk-element-card__info-cell"
          >
            <div class="cherk-element-card__info-label">{{ field.label }}</div>
            <div class="cherk-element-card__info-value">
              <template v-if="field.template">
                <card-section-element-card-field
                  :column-config="field"
                  :element="element"
                  @elements-changed="$emit('elements-changed')"
                />
              </template>
              <template v-else>
                {{ getPropValue(field) || '—' }}
              </template>
            </div>
          </div>
        </div>

        <!-- 4. Comments — 2 cols, single comment spans both -->
        <div
          v-if="mainCommentsFields.length"
          class="cherk-element-card__comments"
          :class="{ 'cherk-element-card__comments--single': mainCommentsFields.length === 1 }"
        >
          <div
            v-for="(field, i) in mainCommentsFields"
            :key="'comment-' + i"
            class="cherk-element-card__comment-box"
          >
            <div class="cherk-element-card__box-label">{{ field.label }}</div>
            <card-section-element-card-field
              :column-config="field"
              :element="element"
              @elements-changed="$emit('elements-changed')"
            />
          </div>
        </div>

      </div>

      <!-- RIGHT column — KPI pays -->
      <div
        v-if="sideFields.length"
        class="cherk-element-card__body-right"
      >
        <div class="cherk-element-card__kpi-header">
          Ключевые результаты выполнения КПЭ
        </div>
        <div class="cherk-element-card__kpi-grid">
          <div
            v-for="(field, i) in sideFields"
            :key="'kpi-' + i"
            class="cherk-element-card__kpi-col"
          >
            <div class="cherk-element-card__kpi-col-label">{{ field.label }}</div>
            <div class="cherk-element-card__kpi-col-content">
              <card-section-element-card-field
                :column-config="field"
                :element="element"
                @elements-changed="$emit('elements-changed')"
              />
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import CardSectionElementCardField from '@/components/cards/CardElementsBlock/CardSectionElementCardField.vue';

export default {
  name: 'cherkizovo-card-section-element-card',
  components: { CardSectionElementCardField },
  props: {
    element: { type: Object, required: true },
    headerFields: { type: Array, default: () => [] },
    bodyFields: { type: Array, default: () => [] },
    expandedByDefault: { type: Boolean, default: false },
    hasError: { type: Boolean, default: false },
  },
  data() {
    return {
      expanded: this.expandedByDefault,
    };
  },
  computed: {
    statsFields() {
      return this.headerFields.filter((f) => f.group === 'stats');
    },
    titleFields() {
      const titled = this.headerFields.filter((f) => f.group === 'title');
      const ungrouped = this.headerFields.filter((f) => !f.group);
      return titled.concat(ungrouped);
    },
    metaFields() {
      return this.headerFields.filter((f) => f.group === 'meta');
    },
    actionFields() {
      return this.headerFields.filter((f) => f.group === 'actions');
    },
    mainScaleFields() {
      return this.bodyFields.filter((f) => f.group === 'main_scale');
    },
    mainPartsFields() {
      return this.bodyFields.filter((f) => f.group === 'main_parts');
    },
    mainInfoFields() {
      return this.bodyFields.filter((f) => f.group === 'main_info');
    },
    mainCommentsFields() {
      return this.bodyFields.filter((f) => f.group === 'main_comments');
    },
    sideFields() {
      return this.bodyFields.filter((f) => f.group === 'side');
    },
  },
  methods: {
    toggle() {
      this.expanded = !this.expanded;
    },
    getPropValue(field) {
      if (!field.prop) return null;
      return this.$companyConfiguration.helpers.getObjectPropByString(this.element, field.prop);
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/css/project-variables";
.cherk-element-card__kpi-grid {
  .click-to-edit-div span {
    -webkit-line-clamp: initial !important;
  }

  .click-to-edit-div {
    height: 100% !important;
  }

  .click-to-edit-div > div {
    height: 100% !important;
  }
}

.cherk-element-card {
  position: relative;
  border: 1px solid #e4e7ed;
  border-left: 3px solid #e4e7ed;
  border-radius: $--border-radius-base;
  margin-bottom: 8px;
  background: #fff;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  }

  &--expanded {
    border-left-color: $--color-primary;
    border-color: mix(white, $--color-primary, 65%);
    box-shadow: 0 2px 12px rgba($--color-primary, 0.10);
  }

  &--error {
    background-color: mix(white, $--color-danger, 95%);
    border-left-color: $--color-danger;
  }

  // ── HEADER ──────────────────────────────────────────────────────────────
  &__header {
    display: flex;
    flex-direction: column;
    gap: 0;
    cursor: pointer;
    border-radius: $--border-radius-base;
    transition: background-color 0.12s ease;
  }

  &--expanded &__header {
    border-bottom: 1px solid #f0eeff;
    border-radius: $--border-radius-base $--border-radius-base 0 0;
  }

  // Each row inside the header
  &__header-row {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;

    &--title {
      // Title row: goal name fills space, actions + chevron on the right
      padding-bottom: 6px;
    }

    &--stats {
      // Stats row: left-aligned pills + right-aligned bonus
      justify-content: space-between;
      padding-top: 0;
      padding-bottom: 8px;
    }
  }

  &__stats {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-shrink: 0;
    flex-wrap: wrap;
  }

  // Individual stat pill — label + value on same horizontal line
  &__stat {
    display: flex;
    align-items: center;
    gap: 6px;
    border: 1px solid mix(white, $--color-primary, 78%);
    padding: 0 10px;
    white-space: nowrap;
    min-height: 45px;

    // Ensure click-to-edit area is always clickable even when empty
    .click-to-edit-div {
      min-width: 64px;
      min-height: 22px;
    }
  }

  &__stat-label {
    color: mix(black, $--color-primary, 35%);
    font-size: 11px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    flex-shrink: 0;
  }

  // Title — full-width, prominent name field
  &__title {
    flex: 1 1 auto;
    min-width: 0;
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 16px;
    border: 1px solid mix(white, $--color-primary, 78%);
    padding: 9px;

    // The direct child is the component root — make it fill the space
    > * {
      width: 100%;
      flex: 1;
    }

    .el-row {
      width: 100%;
      flex-wrap: nowrap;
    }

    .click-to-edit-div {
      display: block;
      width: 100%;
    }
  }

  // Highlighted bonus pill — stands out with primary color
  &__meta-bonus {
    display: flex;
    align-items: center;
    gap: 10px;
    border-radius: 8px;
    padding: 0 15px;
    min-height: 45px;
    flex-shrink: 0;
    white-space: nowrap;
  }

  &__meta-bonus-label {
    color: #860024;
    font-size: 14px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.3px;
  }

  &__meta-bonus-value {
    color: #303133;
    font-size: 16px;
    font-weight: 700;
    line-height: 1;
  }

  &__actions {
    display: flex;
    align-items: center;
    flex-shrink: 0;
  }

  &__chevron {
    flex-shrink: 0;
    padding: 0;
    color: mix(white, $--color-primary, 45%);
  }

  // ── BODY ────────────────────────────────────────────────────────────────
  &__body {
    display: grid;
    grid-template-columns: 2fr 3fr;
    gap: 10px;
    padding: 12px;
    background: #fafafa;
    border-radius: 0 0 $--border-radius-base $--border-radius-base;
  }

  &__body-left {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  // Generic box (scale row)
  &__box {
    background: #fff;
    border: 1px solid #e8e8f0;
    border-radius: $--border-radius-base;
    padding: 8px 10px;

    .click-to-edit-div,
    .click-to-edit-enabled {
      display: block;
      width: 100%;
    }

    .el-select {
      width: 100%;
    }
  }

  &__box-label {
    color: mix(black, $--color-primary, 30%);
    font-size: 11px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    margin-bottom: 6px;
  }

  // Parts row — already a 3-col grid inside CherkizovoCardPartTop/Manual
  &__parts {
    background: #fff;
    border: 1px solid #e8e8f0;
    border-radius: $--border-radius-base;
    padding: 10px;
    min-height: 130px;
    display: flex;
    flex-direction: column;

    // Make the inner part component fill the full height
    > * {
      flex: 1;
      height: 100%;
    }

    // Columns inside the part component should also fill height
    .cherkizovo-card-part-manual,
    .cherkizovo-card-part-top {
      height: 100%;

      &__col {
        height: 100%;

        // Textarea / select fills the column
        .el-textarea,
        .el-select {
          flex: 1;
        }

        .el-textarea__inner {
          height: 100%;
          resize: none;
        }
      }
    }
  }

  // Info row: Ответственный / ID / ID Парт
  &__info-row {
    display: flex;
    gap: 0;
    border: 1px solid #e8e8f0;
    border-radius: $--border-radius-base;
    background: #fff;
    overflow: hidden;
  }

  &__info-cell {
    flex: 1;
    padding: 8px 12px;
    border-right: 1px solid #e8e8f0;

    &:last-child {
      border-right: none;
    }
  }

  &__info-label {
    color: mix(black, $--color-primary, 30%);
    font-size: 11px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    margin-bottom: 4px;
  }

  &__info-value {
    font-size: 13px;
    color: #303133;
    min-height: 20px;
  }

  // Comments row — 2 columns
  &__comments {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;

    &--single {
      grid-template-columns: 1fr;
    }
  }

  &__comment-box {
    background: #fff;
    border: 1px solid #e8e8f0;
    border-radius: $--border-radius-base;
    padding: 8px 10px;
    min-height: 120px;

    .comment-preview {
      min-height: 80px;
    }
  }

  // ── RIGHT: KPI block ─────────────────────────────────────────────────────
  &__body-right {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  &__kpi-header {
    text-align: center;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    color: mix(black, $--color-primary, 30%);
    padding: 4px 2px;
  }

  &__kpi-grid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 6px;
    flex: 1;
  }

  &__kpi-col {
    display: flex;
    flex-direction: column;
    background: #fff;
    border: 1px solid #e8e8f0;
    border-radius: $--border-radius-base;
    overflow: hidden;
    min-height: 180px;
  }

  &__kpi-col-label {
    border-bottom: 1px solid mix(white, $--color-primary, 72%);
    color: mix(black, $--color-primary, 35%);
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    padding: 6px 8px;
    text-align: center;
  }

  &__kpi-col-content {
    flex: 1;
    padding: 8px;
    display: flex;
    flex-direction: column;

    // ClickToEdit root div
    > div {
      flex: 1;
      display: flex;
      flex-direction: column;
    }

    // Make the click-to-edit container fill the column height
    .click-to-edit-div {
      flex: 1;
      display: flex;
      flex-direction: column;

      // View mode: span should grow to fill the space
      > div,
      > span {
        flex: 1;
        display: block;
        white-space: pre-line;
      }
    }

    .el-textarea {
      flex: 1;
      display: flex;
      flex-direction: column;
    }

    .el-textarea__inner {
      flex: 1;
      height: 100% !important;
      resize: none;
    }
  }
}
</style>
